export const simpleTimedToastPreset = {
    name: 'mwSimpleTimed',
    methods: [
        'textContent',
        'theme',
        'parent'
    ],

    options: () => {
        'ngInject';
        return {
            template: `
                <md-toast>
                    <div class="md-toast-content">
                        <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">
                            {{ $ctrl.textContent }}
                        </span>
                    </div>
                </md-toast>
            `,
            hideDelay: 3000,
            position: 'bottom left',
            controller: () => {
                'ngInject';
            },
            controllerAs: '$ctrl',
            bindToController: true
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/toast/presets/simple-timed.toast.preset.ts